import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ErrorToast, SuccessToast } from '../../components';
import {
  getUserRegisterFromLS,
  setUserRegisterToLS
} from '../../helpers/localstorage-helper';
import { LOGIN, PROFILE_DETAILS } from '../../routes/routes';

interface SignUpPasswordType {
  id: number;
  password: string;
  history: any;
}

export const signUpPassword = createAsyncThunk(
  'auth/signUpPassword',
  async (
    { id, password, history }: SignUpPasswordType,
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await axios.put(`/authorization/signup/password`, {
        userId: id,
        password: password
      });

      history.push(PROFILE_DETAILS);

      const { referrer } = getUserRegisterFromLS();

      const user = {
        user: data.data.user,
        referrerId: data.data.user.referrerId,
        referrer: {
          name: referrer.name,
          surname: referrer.surname
        }
      };

      setUserRegisterToLS(user);

      return user;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
